import { Ref, inject, computed } from "vue"
import { useRoute } from "vue-router"

export function useAuthorisation(): { unauthorised: Ref<boolean> } {
  const permission = inject<{ has: (permissionName: string) => null }>(
    "$permission",
  )
  const route = useRoute()

  const unauthorised = computed(() => {
    if (!route.meta.permissions) return false
    return !route.meta.permissions.every((permissionName: string) =>
      permission?.has(permissionName),
    )
  })

  return { unauthorised }
}
